import { Autocomplete, Dialog, DialogContent, DialogTitle, IconButton, Stack, TextField, Typography } from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
import { useEffect } from "react";

const BillScreenViewer = ({ open, onClose, dataURL, heading }) => {

useEffect(() => {
  const handleMessage = (event) => {
 

    if (event.data) {
      window.parent.postMessage(event.data, "*");

    }
  };

  window.addEventListener("message", handleMessage);

  return () => {
    window.removeEventListener("message", handleMessage);
  };
}, []);


    return (
        <Dialog open={open}  fullScreen
            // PaperProps={{
            //     sx: {
            //         height: "95vh",
            //     },
            // }}
            >
            <DialogTitle bgcolor={"#f4f5f8"} fontSize={15} fontWeight={600} color="#4c82ec" >{heading}</DialogTitle>
            <IconButton
                aria-label="close"
                // onClick={onClose}
                onClick={() => {
                    onClose();
                     window.parent.postMessage("ShowMenu", "*");
                }}
                sx={(theme) => ({
                    position: 'absolute',
                    right: 8,
                    top: 8,
                    color: theme.palette.grey[500],
                })}
            >
                <CloseIcon />
            </IconButton>
            <DialogContent sx={{ padding: 0.5 }}>
                <iframe src={dataURL} height={"100%"} width={"100%"}
                    style={{
                        border: "none",
                        // transform: "scale(1.05)",
                        // transformOrigin: "0 0",
                    }} />

            </DialogContent>

        </Dialog >
    )
}

export default BillScreenViewer;